/* eslint-disable camelcase */

export default class DtoPgsseDiagnosticWithIndicators {
    constructor(obj) {
        this.idDiag = obj.idDiag // Option[Long],
        this.idContributor = obj.idContributor // Option[Long],
        this.idSector = obj.idSector // Option[Long],
        this.idUdi = obj.idUdi // Option[Long],
        this.nbIndicators = obj.nbIndicators // Option[Int],
        this.nbFilledThisMonth = obj.nbFilledThisMonth // Option[Int],
        this.nbNotFilledThisMonth = obj.nbNotFilledThisMonth // Option[Int],
    }
}
